import {
	type ConnectionLineComponentProps,
	getSmoothStepPath,
} from "@xyflow/react"

function getSourceSocketMaskRadius(
	width?: number | null,
	height?: number | null,
) {
	const size = Math.min(width ?? 0, height ?? 0)
	if (!size) return 5

	return Math.max(5, size / 2 - 6)
}

function getMaskBounds(
	sourceX: number,
	sourceY: number,
	targetX: number,
	targetY: number,
) {
	const minX = Math.min(sourceX, targetX) - 80
	const minY = Math.min(sourceY, targetY) - 80

	return {
		x: minX,
		y: minY,
		width: Math.abs(sourceX - targetX) + 160,
		height: Math.abs(sourceY - targetY) + 160,
	}
}

export function NodeConnectionLine({
	fromX,
	fromY,
	toX,
	toY,
	fromPosition,
	toPosition,
	fromHandle,
}: ConnectionLineComponentProps) {
	const [connectionPath] = getSmoothStepPath({
		sourceX: fromX,
		sourceY: fromY,
		targetX: toX,
		targetY: toY,
		sourcePosition: fromPosition,
		targetPosition: toPosition,
		borderRadius: 20,
	})
	const isSocketSource =
		typeof fromHandle.width === "number" &&
		typeof fromHandle.height === "number" &&
		Math.abs(fromHandle.width - fromHandle.height) < 0.5
	const maskId = "oblique-connection-line-mask"
	const maskBounds = getMaskBounds(fromX, fromY, toX, toY)

	return (
		<g className="pointer-events-none">
			<defs>
				<mask
					id={maskId}
					maskUnits="userSpaceOnUse"
					x={maskBounds.x}
					y={maskBounds.y}
					width={maskBounds.width}
					height={maskBounds.height}
				>
					<rect
						x={maskBounds.x}
						y={maskBounds.y}
						width={maskBounds.width}
						height={maskBounds.height}
						fill="white"
					/>
					{isSocketSource ? (
						<circle
							cx={fromX}
							cy={fromY}
							r={getSourceSocketMaskRadius(fromHandle.width, fromHandle.height)}
							fill="black"
						/>
					) : null}
				</mask>
			</defs>
			<path
				d={connectionPath}
				fill="none"
				stroke="var(--node-selection-glow)"
				strokeWidth={8}
				strokeLinecap="round"
				opacity={0.16}
				mask={`url(#${maskId})`}
			/>
			<path
				d={connectionPath}
				fill="none"
				stroke="var(--node-selection)"
				strokeWidth={5}
				strokeLinecap="round"
				strokeDasharray="0"
				opacity={0.92}
				mask={`url(#${maskId})`}
			/>
		</g>
	)
}
